export const ratingFeedback = {
    positive: 'positive',
    negative: 'negative',
}
